import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApvpGroupNumberLookupComponent } from './apvp-group-number-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ApvpGroupNumberLookupComponent],
  exports: [ApvpGroupNumberLookupComponent]
})
export class ApvpGroupNumberLookupModule { }
